module.exports = __webpack_public_path__ + "img/home_swiper_01.e51b1d02.jpg";